import { cloneElement, forwardRef, useImperativeHandle } from 'react';

import useLazy from '@/hooks/useLazy';
import dynamic from 'next/dynamic';

const DynamicStudentBenefitsPopup = dynamic(() => import('./student-benefits-content'), { ssr: false });

const StudentBenefitsPopup = forwardRef(({ children, ...rest }: any, ref) => {
  const { show, hide, visible, loaded } = useLazy();
  useImperativeHandle(ref, () => {
    return {
      show,
      hide
    };
  });
  return (
    <>
      {!!children &&
        cloneElement(children, {
          onClick: show
        })}
      {loaded && <DynamicStudentBenefitsPopup {...rest} visible={visible} onCancel={hide} />}
    </>
  );
});

export default StudentBenefitsPopup;
